import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initialState = {
	transfers: null,
  locations: null,

  open: null,
  pending: null,
  incoming: null,
  closed: null,
  closedPage: 1,

  counts: {
    open: null,
    pending: null,
    closed: null,
  },

  closedLgd: null,
  countsLgd: {
    open: null,
    pending: null,
    closed: null,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.TRANSFERS_SET:
      return transfersSet(state, action);
    case constants.TRANSFERS_SET_LOCATIONS:
      return transfersSetLocations(state, action);
    case constants.TRANSFERS_INCOMING_SET:
      return transfersSetIncoming(state, action);
    case constants.TRANSFERS_PENDING_SET:
      return transfersSetPending(state, action);
    case constants.TRANSFERS_OPEN_SET:
      return transfersSetOpen(state, action);
    case constants.TRANSFERS_CLOSED_SET:
      return transfersSetClosed(state, action);
    case constants.TRANSFERS_CLOSED_SET_LGD:
      return transfersSetLgdClosed(state, action);
    case constants.TRANSFERS_SET_COUNTS:
      return transfersSetCounts(state, action);
    case constants.TRANSFERS_SET_LGD_COUNTS:
      return transfersSetLgdCounts(state, action);
    case constants.TRANSFERS_SET_CLOSED_PAGE:
      return transfersSetClosedPage(state, action);
    default:
      return state;
  }
}

function transfersSet(state, action) {
  return Object.assign({}, state, {
    transfers: action.transfers
  });
}

function transfersSetIncoming(state, action) {
  return Object.assign({}, state, {
    incoming: action.transfers
  });
}

function transfersSetPending(state, action) {
  return Object.assign({}, state, {
    pending: action.transfers
  });
}

function transfersSetOpen(state, action) {
  return Object.assign({}, state, {
    open: action.transfers
  });
}

function transfersSetClosed(state, action) {
  return Object.assign({}, state, {
    closed: action.transfers
  });
}

function transfersSetLgdClosed(state, action) {
  return Object.assign({}, state, {
    closedLgd: action.transfers
  });
}

function transfersSetLocations(state, action) {
  return Object.assign({}, state, {
    locations: action.locations
  });
}

function transfersSetCounts(state, action) {
  return Object.assign({}, state, {
    counts: action.counts
  });
}

function transfersSetLgdCounts(state,action) {
  return Object.assign({}, state, {
    countsLgd: action.counts
  });
}

function transfersSetClosedPage(state, action) {
  return Object.assign({}, state, {
    closedPage: action.page
  });
}

